import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiDscAcceptanceTO, ApiDscTO, DscAcceptancePayload, DscPayload } from './api-compliance-adapter.models';

import { HttpRequestsService } from '@core/infrastructure/http-requests/http-requests.service';

@Injectable()
export class ApiComplianceAdapterService {
    constructor(
        private readonly requestService: HttpRequestsService,
        private readonly http: HttpClient
    ) { }

    public createDistanceSaleContract(dscPayload: DscPayload, languageId: string): Observable<ApiDscTO> {
        const slug = `documents/dsc/store/${dscPayload.storeId}`;

        const url = this.requestService.requestUrl(slug, languageId, undefined, undefined, '1');

        const options = {
            withCredentials: true,
        };

        return this.http.post<ApiDscTO>(url, dscPayload, options);
    }

    public acceptDistanceSaleContract(dscAcceptancePayload: DscAcceptancePayload, languageId: string): Observable<boolean> {
        const slug = `documents/accepted/store/${dscAcceptancePayload.storeId}`;

        const url = this.requestService.requestUrl(slug, languageId, undefined, undefined, '1');

        const options = {
            withCredentials: true,
        };

        return this.http.post<ApiDscAcceptanceTO>(url, dscAcceptancePayload, options).pipe(
            map((response) => {
                if (response?.dynamicDocument?.code !== 200 || response?.dynamicDocument?.message !== 'SUCCESS') {
                    return false;
                }

                return true;
            })
        );
    }
}
